<template>
  <v-card>
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        FAQ - Thème
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="cancel"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <v-form
      ref="form"
      v-model="valid"
      class="mt-6"
    >
      <AgrialInput
        v-model="themeModifiable.libelle"
        class="px-5"
        label="Libellé du thème"
        :rules="rules.libelle"
        required
      />
    </v-form>
    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        @click="cancel"
      >
        Annuler
      </AgrButton>
      <AgrButton
        color="primary darken-1"
        :disabled="!valid"
        @click="saveTheme"
      >
        Valider
      </AgrButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import AgrialInput from '@/components/form/agrial-input.vue'
import {clone} from '@/utils/clone'

export default {
  name: 'FaqThemeSaisie',
  components: { AgrButton, AgrialInput },
  props: {
    theme: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      themeModifiable: {},
      valid: false,
      rules: {
        libelle: [
          v => !!v || 'Obligatoire'
        ]
      }
    }
  },

  watch: {
    theme: {
      handler () {
        this.themeModifiable = clone(this.theme)
      },
      immediate: true
    }
  },

  methods: {
    cancel () {
      this.$emit('cancel')
    },

    saveTheme () {
      this.$emit('saveTheme', this.themeModifiable)
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>